import { colors, fonts, screens } from "@theme/constants";

const emotionTheme = { colors, fonts, screens };

export default emotionTheme;
